import { Relationship } from "@covertree/new-business-graphql";

export const mapAdditionalInsuredRelationship = (value: Relationship) => {
  switch (value) {
    case Relationship.Friend:
      return "Friend";
    case Relationship.Officer:
      return "Officer";
    case Relationship.Other:
      return "Other";
    case Relationship.OtherFamily:
      return "Other Family";
    case Relationship.Owner:
      return "Second Owner";
    case Relationship.Partner:
      return "Partner";
    case Relationship.Spouse:
      return "Spouse";
    case Relationship.Trustee:
      return "Trustee";
    default:
      return "Other";
  }
};
